var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.filteredPromotions.length > _vm.minimumNumberOfPromoToggles
    ? _c("div", [
        _c(
          "div",
          { staticClass: "rb-promo-toggles" },
          [
            _vm.togglesAreLoading
              ? _vm._l(3, function (i) {
                  return _c("rb-promo-toggle", {
                    key: i,
                    attrs: { "is-active": false, loading: true },
                  })
                })
              : _vm.canShowPromoPanel
              ? [
                  _vm._l(_vm.toggles, function (promo, i) {
                    return [
                      promo.isFlash && _vm.isFlashVisible
                        ? [
                            _c("rb-promo-toggle", {
                              key: i,
                              staticClass: "rb-promo-toggle--wrapper",
                              attrs: {
                                "data-mnt-header-filter": promo.name,
                                "is-active": _vm.isPromoActive(promo.id),
                                name: promo.name,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.handlePromoPanel(promo.id)
                                },
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "resting",
                                    fn: function () {
                                      return [
                                        _c("span", {
                                          staticClass:
                                            "common__icon common__icon--promo-flash",
                                        }),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                  {
                                    key: "active",
                                    fn: function () {
                                      return [
                                        _c("span", {
                                          staticClass:
                                            "common__icon common__icon--promo-flash",
                                        }),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                  {
                                    key: "label",
                                    fn: function () {
                                      return [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              _vm.labelToShow(promo.badge)
                                            ) +
                                            "\n            "
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ]
                        : [
                            _c("rb-promo-toggle", {
                              key: i,
                              staticClass: "rb-promo-toggle--wrapper",
                              attrs: {
                                "data-mnt-header-filter": promo.name,
                                "is-active": _vm.isPromoActive(promo.id),
                                name: promo.name,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.handlePromoPanel(promo.id)
                                },
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "resting",
                                    fn: function () {
                                      return [
                                        _c(
                                          "span",
                                          {
                                            class: [
                                              "common__icon",
                                              _vm.getPromoIcon(promo),
                                            ],
                                          },
                                          [_vm._v(_vm._s(promo.label))]
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                  {
                                    key: "active",
                                    fn: function () {
                                      return [
                                        _c(
                                          "span",
                                          {
                                            class: [
                                              "common__icon",
                                              _vm.getPromoIconActive(promo),
                                            ],
                                          },
                                          [_vm._v(_vm._s(promo.badge))]
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                  {
                                    key: "label",
                                    fn: function () {
                                      return [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              _vm.labelToShow(promo.badge)
                                            ) +
                                            "\n            "
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                    ]
                  }),
                ]
              : _vm._e(),
          ],
          2
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }